/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useEffect } from 'react';
import { useLeaflet } from 'react-leaflet';
import { GeoSearchControl } from 'leaflet-geosearch';

// Types
import { SearchControlInterface } from './types';

interface SearchControlProps extends SearchControlInterface {}

const SearchControl: React.FC<SearchControlProps> = ({
  provider,
  style,
  ...rest
}) => {
  const { map } = useLeaflet();
  // @ts-ignore
  useEffect(() => {
    const searchControl = GeoSearchControl({
      provider,
      style: 'bar',
      ...rest,
    });

    // eslint-disable-next-line no-unused-expressions
    map?.addControl(searchControl);

    return () => map?.removeControl(searchControl);
  }, [map, provider, rest, style]);

  return null;
};

export default SearchControl;
export { SearchControl };
